import { IMAGES, NEWS_ITEMS } from "../data/content";
import { PageHero } from "../components/shared/PageHero";
import { Reveal } from "../components/shared/Reveal";

export default function News() {
  return (
    <>
      <PageHero
        eyebrow="News & Announcements"
        title="The Story Begins"
        intro="Official Kumite Games announcements will be published here — the event reveal, new martial arts, federation partnerships, the venue announcement and athlete information."
        image={IMAGES.karate}
        testId="news-page-hero"
      />
      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {NEWS_ITEMS.map((n, i) => (
            <Reveal key={n.slug} delay={(i % 3) * 0.08}>
              <article
                data-testid={`news-article-${n.slug}`}
                className="group clip-frame overflow-hidden border border-white/5 bg-ink-card"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={IMAGES[n.image]}
                    alt=""
                    loading="lazy"
                    className="h-full w-full object-cover opacity-50 transition-all duration-700 group-hover:scale-105 group-hover:opacity-75"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink-card to-transparent" />
                  <span className="absolute left-4 top-4 bg-kred px-3 py-1 font-mono text-[9px] font-bold uppercase tracking-[0.25em] text-white">
                    {n.tag}
                  </span>
                </div>
                <div className="p-7">
                  <h2 className="font-head text-lg font-bold uppercase tracking-wide text-bone">
                    {n.title}
                  </h2>
                  <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                    Coming Soon
                  </p>
                  <p className="mt-4 text-sm leading-relaxed text-slate-500">
                    This announcement is being prepared. Check back for the official release.
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
